// src/lib/lazyRoute.ts
import { lazy, type ComponentType } from "react";

// Nach einem Deploy zeigt eine offene Seite noch auf alte Chunk-Dateinamen.
// Das Nachladen schlägt dann fehl. Wir laden die Seite genau einmal neu;
// das sessionStorage-Flag verhindert eine Reload-Schleife.
const RELOAD_KEY = "propora_chunk_reload";
// Nachtrag 14.10.2026 (Dominiks Befund: Klick auf "Alle Details im Analyzer" aendert die URL,
// rendert die neue Route aber nicht -- plausibelste Erklaerung: ein Browser-Tab war noch auf
// dem JS-Bundle des VORHERIGEN Deploys offen, und der Chunk der Ziel-Route existiert unter der
// alten Datei-Hash-URL nicht mehr -- siehe vercel.json: ein 404 auf einen Asset-Pfad faellt auf
// den SPA-Catch-all zurueck und liefert index.html (200, text/html) statt JS zurueck, was den
// dynamischen Import ebenfalls fehlschlagen laesst). Die bisherige Regex deckte nur Chromes/
// Safaris genaue Formulierung ab -- Firefox formuliert anders ("error loading dynamically
// imported module"); ergaenzt fuer breitere Browser-Abdeckung desselben Fehlerfalls.
const CHUNK_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|ChunkLoadError/i;

export function lazyRoute<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const mod = await load();
      try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* Storage nicht verfügbar */ }
      return mod;
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      let alreadyReloaded = false;
      try { alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === "1"; } catch { /* ignorieren */ }

      if (CHUNK_ERROR.test(message) && !alreadyReloaded) {
        try { sessionStorage.setItem(RELOAD_KEY, "1"); } catch { /* ignorieren */ }
        window.location.reload();
        // Seite wird neu geladen; die Promise bleibt bewusst offen.
        return new Promise<never>(() => {});
      }
      throw err;
    }
  });
}
